/**
 * TopBar route helpers — pathname → crumb/title, course filter, and title visibility.
 * Presentation only; keeps TopBar free of duplicate headers when a page renders PageHero.
 */

/** Map a portal pathname to a { crumb, title } pair for the bar. */
export function resolvePage(pathname) {
  const sub = pathname.replace(/^\/Portal\/Instructor/, '') || '/';
  const has = (...parts) => parts.some((p) => sub.toLowerCase().startsWith(p.toLowerCase()));

  if (sub === '/' || has('/today')) return { crumb: 'Overview', title: 'Dashboard' };
  if (has('/Assignment', '/Questions', '/AssessmentSetting', '/AssessmentDetail')) return { crumb: 'Teaching', title: 'Assessments' };
  if (has('/Course', '/CourseDetail', '/CourseSetting')) return { crumb: 'Teaching', title: 'Courses' };
  if (has('/score')) return { crumb: 'Results', title: 'Scores' };
  if (has('/addEnrollee', '/resultDetails')) return { crumb: 'People', title: 'Enrollments' };
  if (has('/analysis')) return { crumb: 'Insights', title: 'Analysis' };
  if (has('/billing')) return { crumb: 'Admin', title: 'Billing' };
  if (has('/admin')) return { crumb: 'Admin', title: 'Administration' };
  if (has('/settings')) return { crumb: 'Settings', title: 'Settings' };
  if (has('/organisation', '/Register')) return { crumb: 'Admin', title: 'Organisation' };
  if (has('/course-catalog')) return { crumb: 'Teaching', title: 'Course catalog' };
  if (has('/ImportCourse')) return { crumb: 'Workspace', title: 'Course Catalog' };
  if (has('/courseSelector')) return { crumb: 'Teaching', title: 'Registration requests' };
  if (has('/setting', '/system', '/packages', '/packageDetails')) return { crumb: 'Workspace', title: 'Settings' };
  if (has('/account', '/profile')) return { crumb: 'Settings', title: 'Account' };
  if (has('/Training', '/Workflow')) return { crumb: has('/Workflow') ? 'Setup' : 'Training', title: has('/Workflow') ? 'Workflow' : 'Training' };
  return { crumb: 'Instructor', title: 'Portal' };
}

/** Course filtering is relevant on Enrollments, Scores, Training, and Assessments. */
export function showsCourseFilter(pathname) {
  const sub = pathname.replace(/^\/Portal\/Instructor/, '') || '/';
  return ['/addEnrollee', '/score', '/resultDetails', '/Training', '/Assignment', '/Questions', '/AssessmentDetail'].some(
    (p) => sub.toLowerCase().startsWith(p.toLowerCase()),
  );
}

/**
 * Pages that render their own PageHero should not duplicate eyebrow/title in TopBar.
 * Scores uses TopBar for "Results / Scores"; section head below is "Scores & results".
 */
export function hidesPageTitle(pathname) {
  const sub = pathname.replace(/^\/Portal\/Instructor/, '') || '/';
  return [].some((p) => sub.toLowerCase().startsWith(p.toLowerCase()));
}
